import { ComponentType, useContext } from "react";

import { OverviewEngineFactories } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";
import {
	ComponentMap,
	DefaultComponentMap
} from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/component-map";
import {
	DefaultWidgetMap,
	WidgetMap
} from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/widget-map";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import {
	DateTimePickerInputProps,
	DateTimePickerProps
} from "@com.mgmtp.a12.widgets/widgets-core/lib/date-time-picker";
import { DateInputProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/datepicker";
import { TimePickerProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/time-picker";

export const GeneralOverviewEngine: ComponentType<OverviewEngineFactories.ViewComponentProps> =
	function GeneralOverviewEngine(props) {
		return (
			<OverviewEngineFactories.ViewComponent
				componentMap={GeneralOverviewComponentMap}
				widgetMap={GeneralOverviewWidgetsMap}
				{...props}
			/>
		);
	};

Object.assign(GeneralOverviewEngine, {
	handleProgressIndicator: OverviewEngineFactories.ViewComponent.handleProgressIndicator
});

// Vordefiniert damit nicht alle stellen, die es benutzen bei Anpassungen umgeschrieben werden müssen.
export const GeneralOverviewComponentMap: ComponentMap = {
	...DefaultComponentMap
};

const CustomDateInput: ComponentType<DateInputProps> = function CustomDateInput(props) {
	const { localizer } = useContext(LocalizerContext);

	const placeholder = localizer({
		key: "none",
		defaults: { de: "$dateFormat$", en: "$dateFormat$" },
		args: { dateFormat: { type: "dataFormat", value: "yyyy-MM-dd", properties: { type: "date" } } }
	});

	return (
		<DefaultWidgetMap.DateInput
			hideLabel
			label={props.placeholder}
			{...props}
			placeholder={placeholder ?? props.placeholder}
		/>
	);
};

const CustomDateTimePickerInput: ComponentType<DateTimePickerInputProps<DateTimePickerProps>> =
	function CustomDateTimePickerInput(props) {
		const { localizer } = useContext(LocalizerContext);

		const placeholder = localizer({
			key: "none",
			defaults: { de: "$dateFormat$", en: "$dateFormat$" },
			args: { dateFormat: { type: "dataFormat", value: "yyyy-MM-dd'T'HH:mm:ss", properties: { type: "date" } } }
		});

		return (
			<DefaultWidgetMap.DateTimePickerInput
				hideLabel
				inputLabel={props.placeholder}
				{...props}
				placeholder={placeholder ?? props.placeholder}
			/>
		);
	};

const CustomTimePicker: ComponentType<TimePickerProps> = function CustomTimePicker(props) {
	const { localizer } = useContext(LocalizerContext);

	const placeholder = localizer({
		key: "none",
		defaults: { de: "$dateFormat$", en: "$dateFormat$" },
		args: { dateFormat: { type: "dataFormat", value: "HH:mm:ss", properties: { type: "date" } } }
	});

	return (
		<DefaultWidgetMap.TimePicker
			hideLabel
			label={props.placeholder}
			{...props}
			placeholder={placeholder ?? props.placeholder}
		/>
	);
};

export const GeneralOverviewWidgetsMap: WidgetMap = {
	...DefaultWidgetMap,
	DateInput: CustomDateInput,
	DateTimePickerInput: CustomDateTimePickerInput,
	TimePicker: CustomTimePicker
};
